import React from "react";
import { Button, Box, TextField, Typography } from "@mui/material";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Style from "./style";

const EditName = () => {
  const schemaResolver = yupResolver(
    yup.object().shape({
      firstName: yup.string().trim().required("Please enter first name"),
      lastName: yup.string().trim().required("Please enter last name"),
    })
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: schemaResolver,
    defaultValues: {
      firstName: "",
      lastName: "",
    },
  });
  const onSubmit = async (values) => {
    console.log("val", values);
  };

  return (
    <>
      <Style.TableWrapper>
        <form className="editname-form" onSubmit={handleSubmit(onSubmit)}>
          <Box>
            <Typography>First Name</Typography>
            <Controller
              name="firstName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  variant="outlined"
                  placeholder="Enter your first name"
                  fullWidth
                  size="small"
                  {...field}
                  error={!!errors?.firstName}
                  helperText={errors?.firstName?.message}
                />
              )}
            />
          </Box>
          <Box mt={2}>
            <Typography>Last Name</Typography>
            <Controller
              name="lastName"
              control={control}
              defaultValue=""
              fullWidth
              render={({ field }) => (
                <TextField
                  placeholder="Enter your last name"
                  variant="outlined"
                  fullWidth
                  size="small"
                  {...field}
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                />
              )}
            />
          </Box>
          <Button
            size="small"
            type="submit"
            variant="contained"
            color="primary"
            sx={{
              marginTop: "12px",
              textTransform: "none",
              width: '70px'
            }}
          >
            Update
          </Button>
        </form>
      </Style.TableWrapper>
    </>
  );
};

export default EditName;
